<template>
  <div class="flex flex-col mt-2 md:mt-0 h-full">
    <tabs-wrapper v-if="show" contentClass="md:px-8 md:pt-4">
      <tab title="הודעות אוטומטיות" description="הגדרת הודעות שנשלחות אוטומטית — תזכורות, אישורי תור, משוב ועוד">
        <automations-tab/>
      </tab>
      <tab title="מילוי יומן חכם" :badge="automationsStore.nudgeCount" description="הצעות לשליחת הודעה ללקוחות שהגיע זמנם לביקור, מבוסס ניתוח מחזור ביקורים">
        <smart-nudge-tab/>
      </tab>
    </tabs-wrapper>
    <loader v-else/>
  </div>
</template>

<script lang="ts" setup>

import {onMounted, ref} from "vue";
import {useAdminStore} from "@app/stores";
import {useAdminAutomations} from "@app/stores/admin-automations";
import {AdminRouteNames} from "@app/router/route-names";
import SmartNudgeTab from "./pages/communication/SmartNudgeTab.vue";
import Tab from './components/admin-tabs/Tab.vue'
import { trackEvent } from '@app/composables/posthog';

const adminStore = useAdminStore();
const automationsStore = useAdminAutomations();
const {setPage} = adminStore;

const show = ref(false);

onMounted(() => {
  setTimeout(() => {
    show.value = true
  }, 200)
})

onMounted(async () => {
  trackEvent('communication_viewed');
  setPage(AdminRouteNames.Communication);
  automationsStore.fetchNudgeCount();
})
</script>

<style scoped lang="scss">
@use '../../../../../../node_modules/@vue-flow/core/dist/style.css' as *;
@use '../../../../../../node_modules/@vue-flow/core/dist/theme-default.css' as *;

</style>
